module.exports = __webpack_public_path__ + "img/apulid.35dbe9d1.png";